import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { PostListItem } from '@/models/features/posts.models'

import { authAPI } from '../new-api'

export type GetPostRequest = {
  buildingId?: number
  groupId?: string
  skip: number
  limit: number
  scheduled?: boolean
}

export type GetPendingCommentsResponse = {
  data: PostListItem[]
  unapprovedCount: number
}

export const GET_POSTS_BASE_QUERY_KEY = 'useGetPosts'

export const getPostsQueryKey = (data: GetPostRequest) => [GET_POSTS_BASE_QUERY_KEY, data]

export const getPosts = async (data: GetPostRequest, signal?: AbortSignal) => {
  const { ...params } = data
  const response = await authAPI.get<GetPendingCommentsResponse>('/group/dashboard/post', {
    params,
    signal,
  })
  return response.data
}

export const useGetPosts = (data: GetPostRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getPosts(data, signal),
    queryKey: getPostsQueryKey(data),
  })
}
